import { gql } from '@apollo/client';

export const CREATE_VORLAGE_STATION = gql`
  mutation mitarbeiter_createVorlageStation(
    $input: mitarbeiter_createVorlageStationInput!
  ) {
    mitarbeiter_createVorlageStation(createVorlageStationInput: $input) {
      success {
        vorlageStation {
          id
        }
      }
      error {
        message
      }
    }
  }
`;
